export enum EClassicHistoryMode {
  ALL = 'all',
  MY = 'my',
}
